import { render, staticRenderFns } from "./payBill.vue?vue&type=template&id=5c235df1&scoped=true"
import script from "./payBill.vue?vue&type=script&lang=js"
export * from "./payBill.vue?vue&type=script&lang=js"
import style0 from "./payBill.vue?vue&type=style&index=0&id=5c235df1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c235df1",
  null
  
)

export default component.exports